import React               from 'react';
import classnames          from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import SelectCellBomParameter  from './SelectCellBomParameter';

const TableHead = (props) => {
  let cols = []
  cols.push(<th className="identify-col" key="selector-cell-head"></th>)
  for (let i = 0; i < props.num_columns; i++) {
    cols.push(<SelectCellBomParameter id={i} 
                key={"selector-cell-" + i} 
                parameters={props.parameters}
                onChange={props.onChange} />);
  }

  return (
    <thead>
      <tr>
        {cols}
      </tr>
    </thead>
  )
}

const TableBody = (props) => {
  let classRow = '';
  let bom_header = props.parameters.header;
  let first_row = props.parameters.first_row;
  let bom_parameters = props.parameters.bom_parameters;

  return (
    <tbody>
      {props.workbook.map((row, i) => (
        <tr key={"row-" + i} 
          className={(bom_header == (i+1)) ? 'header' : ((first_row == (i+1)) ? 'first_row' : '')}>
          <td className="identify-row">{i+1}</td>
          {row.map((cell, j) => (
            <td key={"cell-" + i + "-" + j} 
              className={(bom_parameters[j] !== undefined && bom_parameters[j] !== null) ? 'col-selected' : ''}>
              {cell}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  )
}

const BomImportTable = (props) => {
  if (! Array.isArray(props.workbook)){
    return ("something wrong :(")
  }

  const num_rows =  props.workbook.length;
  const num_columns =  props.workbook[0].length;
  return (
    <div className="import-table">
      <table className="table fixed_header table-responsive">
        <TableHead num_columns={num_columns}
          parameters={props.parameters}
          onChange={props.onChange} />
        <TableBody workbook={props.workbook} 
          parameters={props.parameters} />
      </table>
    </div>
  )
}

export default BomImportTable;